module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e1"
    }
  }, [_vm._v("Acknowledgments ")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e6826"
    }
  }, [_vm._v("Writing any book is a massive undertaking, and no author does it alone, even though you certainly feel alone when it’s 4:30 on a beautiful sunny spring afternoon and you’re stuck inside banging your head against the desk as you try to come up with something funny to say about people being beheaded or bugs that eat human flesh while all your friends and family are outside somewhere having fun without you, usually accompanied by alcohol.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e7086"
    }
  }, [_vm._v("Still, a lot of people made this book happen, and I need to thank them. Especially if I want to get hired again. Those people are:")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e7186"
    }
  }, [_vm._v("Holly Schmidt and Allan Penn at Hollan Publishing, for giving me the opportunity to write this book, for believing in me, for coddling me and listening to me whine and bitch about how hard it was and convincing me it would be worth the effort in the end. It was.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e7376"
    }
  }, [_vm._v("Matt Glazer and Paula Munier at Adams Media, for their guidance and patience, and for giving a first-time author a chance.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e7516"
    }
  }, [_vm._v("Kirsten Amman, my researcher, whose task was monumental; yet she did it with vigor and efficiency and glee. For that I could kiss her, but I don’t want her boyfriend to beat my ass, so she’ll have settle for a heartfelt thank you.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e7676"
    }
  }, [_vm._v("Jenny Bent of The Bent Agency, for her generous and invaluable advice, and Elaine English, my attorney, for reading all the long, wordy documents and knowing exactly which parts were most important.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e7836"
    }
  }, [_vm._v("My friends Don and Danna Calder, for legal assistance, medical supervision, patience, and encouragement, and for entertaining my family while I was holed up writing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e8027"
    }
  }, [_vm._v("Beverly Linzer Jenkins and Adrianne Gershberg, the funniest chicks I know, for their comic genius and inspiration, and all my friends from List of the Day.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e8237"
    }
  }, [_vm._v("Amy Miller and Tom Jacobsen for their unconditional friendship and for waiting months for me to answer their e-mails and return their phone calls.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e8397"
    }
  }, [_vm._v("Amy Winter, my professional role model and friend, and the entire crew at Wolff Bros Post.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e8527"
    }
  }, [_vm._v("My parents, Perry and Jean McNeal, and the rest of my family for their interest in, and support of, my writing.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e8657"
    }
  }, [_vm._v("My wife Paige and daughter Keaton for loving me no matter what.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2b6614c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/McNe_9781605506241_epub_c7_r1.vue
// module id = 72
// module chunks = 0